module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "fm1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmhT"
  }, [_vm._v("\n    Praise for BALANCE YOUR HORMONES, BALANCE YOUR LIFE\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "epiv"
  }, [_vm._v("\n    “Dr. Claudia Welch amalgamates Eastern medicine and Western science into a tidy and practical framework from whose clear perspective we can easily make sense of the complicated particulars of hormones and women’s health.”\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "eps"
  }, [_vm._v("\n    —Dr. Robert Svoboda, BAMS, author of"), _c('br'), _vm._v(" "), _c('i', [_vm._v("Ayurveda for Women: A Guide to Vitality and Health")])]), _vm._v(" "), _c('div', {
    staticClass: "epiv"
  }, [_c('div', [_c('br')]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', [_c('br')]), _vm._v("“A loving, compassionate healer and wonderful teacher, Dr. Claudia Welch has studied Ayurveda and Acupuncture extensively. She provides a new avenue and dimension of perception, integrating these two healing traditions to bring about holistic health.”\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "eps"
  }, [_vm._v("\n    —Vasant Lad, BAMS, MASc, Ayurvedic Physician,"), _c('br'), _vm._v("\n    author of "), _c('i', [_vm._v("The Complete Book of Ayurvedic Home Remedies")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18fb8c34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/clau_9780738214993_oeb_fm1_r1.vue
// module id = 66
// module chunks = 0